import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-virtual-showroom-tour',
  templateUrl: './virtual-showroom-tour.component.html',
  styleUrls: ['./virtual-showroom-tour.component.scss']
})
export class VirtualShowroomTourComponent implements OnInit {

  public listData = [
    { name: 'TA Spring 2024 - Spencer London', url: 'https://my.matterport.com/show/?m=gpe9FduVDVD', imgUrl: '/assets/img/spencer.jpg' },
    { name: 'TA Spring 2024 - Lobby', url: 'https://my.matterport.com/show/?m=fmeTqAVdVZu', imgUrl: '/assets/img/lobby.jpg' },
    { name: 'TA Spring 2024 - Seated', url: 'https://my.matterport.com/show/?m=2TTwWgvxLZ3', imgUrl: '/assets/img/seated.jpg' },
    { name: 'TA Spring 2024 - Wiltshire', url: 'https://my.matterport.com/show/?m=Em7u4QgzGWy', imgUrl: '/assets/img/wiltshire.jpg' },
    { name: 'TA Fall 2023 - Section 1', url: 'https://my.matterport.com/show/?m=usGaWQdqnMU', imgUrl: '/assets/img/virtual-tour_Section_1.jpg' },
    { name: 'TA Fall 2023 - Section 2', url: 'https://my.matterport.com/show/?m=SdBUmAAafM2', imgUrl: '/assets/img/virtual-tour_Section_2.jpg' },
    { name: 'TA Fall 2023 - Section 3', url: 'https://my.matterport.com/show/?m=CGBMDAxugmw', imgUrl: '/assets/img/virtual-tour_Section_3.jpg' },
    { name: 'TA Fall 2023 - Section 4', url: 'https://my.matterport.com/show/?m=uZxc8NNmJkf', imgUrl: '/assets/img/virtual-tour_Section_4.jpg' },
    { name: 'Essence and TA Originals', url: 'https://my.matterport.com/show/?m=mcPSwzEUo3p', imgUrl: '/assets/img/TA Originals_Living room.jpg' },
    { name: 'Kesden', url: 'https://my.matterport.com/show/?m=5sqXR5Hy19p', imgUrl: '/assets/img/Kesden_living.jpg' },
    { name: 'Hudson', url: 'https://my.matterport.com/show/?m=PvnZEe5md67', imgUrl: '/assets/img/Hudson_dining room.jpg' },
    { name: 'Lido', url: 'https://my.matterport.com/show/?m=462irnbcnBB', imgUrl: '/assets/img/TA54047_TAS40006_TAS41006_TA61062.C305.jpg' },
    { name: 'Repose', url: 'https://my.matterport.com/show/?m=PGzdC5Ew5xr', imgUrl: '/assets/img/experience-the-repose-collection_20230417044415638173034552510894.jpg' },
    { name: 'Semi-Custom Barstools', url: 'https://my.matterport.com/show/?m=VJCH7is5bgr', imgUrl: '/assets/img/Bar Stools.jpg' },
  ]

  constructor() { }

  ngOnInit() {
  }

}
